import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ThemeSwitcherComponent } from './theme-switcher/theme-switcher.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ChatViewComponent } from './chat-view/chat-view.component';
import { ChatComponent } from './chat/chat.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { ProgressTrackerComponent } from './progress-tracker/progress-tracker.component';
import { WholeViewComponent } from './graph-view/whole-view/whole-view.component';
import { DomainsViewComponent } from './graph-view/domains-view/domains-view.component';
import { TeamsViewComponent } from './graph-view/teams-view/teams-view.component';
import { TechnologiesViewComponent } from './graph-view/technologies-view/technologies-view.component';
import { GraphDashboardComponent } from './graph-view/graph-dashboard.component';
import { GalaxyViewComponent } from './galaxy/galaxy-view/galaxy-view.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {
      title: 'Galaxy Home',
    },
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    data: {
      title: 'Build-In Notifications',
    },
  },
  {
    path: 'themes',
    component: ThemeSwitcherComponent,
    data: {
      title: 'Theme Switching',
      showHeader: false,
    },
  },
  {
    path: 'chat-view',
    component: ChatViewComponent,
    data: {
      title: 'Chat View', // Remember to add routes in app.component.ts
    },
  },
  {
    path: 'portfolio',
    component: PortfolioComponent,
    data: {
      title: 'Portfolio',
    },
  },
  {
    path: 'progress-tracker',
    component: ProgressTrackerComponent,
    data: {
      title: 'Progress Tracker',
    },
  },
  {
    path: 'chat',
    component: ChatComponent,
    data: {
      title: 'Chat',
    },
  },
  {
    path: 'whole-view',
    component: WholeViewComponent,
    data: {
      title: 'Graph View',
    },
  },
  {
    path: 'technologies-view',
    component: TechnologiesViewComponent,
    data: {
      title: 'Technologies View',
    },
  },
  {
    path: 'teams-view',
    component: TeamsViewComponent,
    data: {
      title: 'Teams View',
    },
  },
  {
    path: 'domians-view',
    component: DomainsViewComponent,
    data: {
      title: 'Domains View',
    },
  },
  {
    path: 'graph-dashboard',
    component: GraphDashboardComponent,
    data: {
      title: 'Graph Dashboard',
    },
  },
  {
    path: 'galaxy-view',
    component: GalaxyViewComponent,
    data: {
      title: 'Galaxy View',
    },
  },
];

//do all the routing in here

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
